import { render, staticRenderFns } from "./DetailsSummary.vue?vue&type=template&id=5ba9f9ff&scoped=true&"
import script from "./DetailsSummary.vue?vue&type=script&lang=js&"
export * from "./DetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSummary.vue?vue&type=style&index=0&id=5ba9f9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9f9ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
